import React, { useRef, useState, useEffect, useCallback } from "react";
import "./productslider.css";
import ProductCard from "./productCard";
import { productData } from "../../productData";

const ProductSlider = () => {
    const tabletProducts = productData.filter(
        (item) => item.category === "tablets"
    );

    const [slidesToShow, setSlidesToShow] = useState(5);
    const [currentGroup, setCurrentGroup] = useState(0);

    const autoPlay = true;
    const autoPlaySpeed = 3000; 
    const autoPlayRef = useRef(null);

    const updateSlidesToShow = () => {
        if (window.innerWidth <= 480) setSlidesToShow(2);
        else if (window.innerWidth <= 768) setSlidesToShow(2);
        else if (window.innerWidth <= 1024) setSlidesToShow(3);
        else setSlidesToShow(5);
    };

    useEffect(() => {
        updateSlidesToShow();
        window.addEventListener("resize", updateSlidesToShow);
        return () => window.removeEventListener("resize", updateSlidesToShow);
    }, []);

   
    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const groups = chunkArray(tabletProducts, slidesToShow);

    const nextSlide = useCallback(() => {
        setCurrentGroup((prev) =>
            prev < groups.length - 1 ? prev + 1 : 0
        );
    }, [groups.length]);

    const prevSlide = useCallback(() => {
        setCurrentGroup((prev) =>
            prev > 0 ? prev - 1 : groups.length - 1
        );
    }, [groups.length]);


    useEffect(() => {
        if (!autoPlay) return;

        autoPlayRef.current = setInterval(() => {
            nextSlide();
        }, autoPlaySpeed);

        return () => clearInterval(autoPlayRef.current);
    }, [autoPlay, autoPlaySpeed, nextSlide]);


    
    let touchStartX = 0;
    const handleTouchStart = (e) => {
        touchStartX = e.touches[0].clientX;
        clearInterval(autoPlayRef.current);
    };

    const handleTouchEnd = (e) => {
        const touchEndX = e.changedTouches[0].clientX;

        if (touchStartX - touchEndX > 50) nextSlide();
        if (touchEndX - touchStartX > 50) prevSlide();
    };

    return (
        <div className="product-container">
            <div className="slider-content" data-aos="fade-up">
                <div className="content-top">
                    <h2 className="content-title">Our Products</h2>
                </div>

                <div className="slider-wrapper">
                    <div
                        className="slider"
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                        style={{
                            width: `${groups.length * 100}%`,
                            display: "flex",
                            transform: `translateX(-${currentGroup * (100 / groups.length)}%)`,
                            transition: "transform 0.5s ease"
                        }}
                    >
                        {groups.map((group, groupIndex) => (
                            <div
                                key={groupIndex}
                                className="group"
                                style={{
                                    width: `${100 / groups.length}%`,
                                    display: "flex",
                                }}
                            >
                                {group.map((item) => (
                                    <div
                                        key={item.id}
                                        className="slide"
                                        style={{
                                            width: `${100 / slidesToShow}%`,
                                        }}
                                    >
                                        <ProductCard item={item} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                    <div className="dots">
                        {groups.map((_, i) => (
                            <span
                                key={i}
                                className={`dot ${i === currentGroup ? "active" : ""}`}
                                onClick={() => {
                                    clearInterval(autoPlayRef.current);
                                    setCurrentGroup(i);
                                }}
                            ></span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductSlider;
